const SCRIPT_SRC = 'https://cdn.xsolla.net/payments-bucket-prod/embed/1.5.4/widget.min.js'

let loadPromise: Promise<void> | null = null

export function loadXsollaWidgetScript(): Promise<void> {
    if (loadPromise) return loadPromise

    loadPromise = new Promise((resolve, reject) => {
        if (document.querySelector(`script[src="${SCRIPT_SRC}"]`)) {
            resolve()
            return
        }

        const script = document.createElement('script')
        script.src = SCRIPT_SRC
        script.async = true
        script.defer = true
        script.onload = () => resolve()
        script.onerror = () => reject(new Error('Failed to load Xsolla Pay Station widget'))
        document.head.appendChild(script)
    })

    return loadPromise
}

declare global {
    const XPayStationWidget: {
        init(options: {
            access_token: string
            sandbox?: boolean
            lightbox?: {
                width?: string
                height?: string
                spinner?: 'round'|'dual_ring'
                spinnerColor?: string
                overlayBackgroundColor?: string
                zIndex?: number
            }
            childWindow?: { target?: '_blank'|'_self'|'_parent' }
        }): void
        open(): void
        close(): void
        on(event: string, handler: (data?: any) => void): void
        off(event: string, handler?: (data?: any) => void): void
        eventTypes: {
            INIT: string
            OPEN: string
            LOAD: string
            CLOSE: string
            STATUS: string
            STATUS_INVOICE: string
            STATUS_DELIVERING: string
            STATUS_DONE: string
            STATUS_TROUBLED: string
        }
    }
}
